import { useEffect } from "react"

import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"

import { userHasRequiredPermissionsState } from "~/containers/Proposal/state/user/user-state"
import type { Permission } from "~/graphql/client"

type RequiredPermission = Permission | `${Permission}`

export const useRequiredPermissions = (
  allowedPermissions: readonly RequiredPermission[],
  redirectTo = `/`,
): void => {
  // This hook is the compatibility boundary for the legacy GraphQL/Recoil
  // permission selector. RequiredPermission already limits callers to enum values.
  const legacyPermissions = allowedPermissions as readonly Permission[]
  const hasRequiredPermissions = useRecoilValue(
    userHasRequiredPermissionsState(legacyPermissions),
  )
  const navigate = useNavigate()

  useEffect(() => {
    if (!hasRequiredPermissions) {
      navigate(redirectTo, { replace: true })
    }
  }, [hasRequiredPermissions, allowedPermissions, redirectTo, navigate])
}
